/** Picks v2 or v1 of User Streaks based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../utils/redesignFlag';
import UserStreakPage   from './UserStreakPage';
import UserStreakPageV2 from './v2/UserStreakPageV2';

export default function UserStreakPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? UserStreakPageV2 : UserStreakPage;
  return <Component {...props} />;
}
